import { render } from "./SECU.vue?vue&type=template&id=024edfab"
import script from "./SECU.vue?vue&type=script&lang=js"
export * from "./SECU.vue?vue&type=script&lang=js"
script.render = render

export default script